'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSimplybuilt = function FaSimplybuilt(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.8 22.6q0-2.1-1.6-3.7t-3.7-1.5-3.7 1.5-1.6 3.7 1.6 3.7 3.7 1.6 3.7-1.6 1.6-3.7z m16.7 0q0-2.2-1.5-3.7t-3.7-1.5-3.8 1.5-1.5 3.7q0 2.2 1.5 3.7t3.8 1.6 3.7-1.6 1.5-3.7z m6.3-15.7v26.2q0 0.8-0.7 1.4t-1.4 0.7h-35.6q-0.9 0-1.5-0.7t-0.6-1.4v-26.2q0-0.8 0.6-1.4t1.5-0.7h8.4q0.8 0 1.4 0.7t0.7 1.4v3.1h14.6v-3.1q0-0.8 0.6-1.4t1.5-0.7h8.4q0.8 0 1.4 0.7t0.7 1.4z' })
        )
    );
};

exports.default = FaSimplybuilt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/simplybuilt.js
// module id = 1006
// module chunks = 168707334958949